<template>
  <div class="dlrLayer-iframe">
    <iframe
      :src="interUrl"
      frameborder="0"
      scrolling="no"
      :width="fullFrame.width"
      :height="fullFrame.height"
      border="0"
      allowtransparency="true"
    />
    <i
      class="loadding-xx funcicons-xx"
      @click="closeInter"
      style="right: 0.8125rem; left: auto"
    ></i>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import layerManager from '../../services/layer.manager';
import * as layerNames from '../../services/layerName';
import config from '../../config';
import { URLService } from '../../services/url.service';
export default {
  props: {
    interiorSpecId: {
      type: [String, Number],
      default: 0
    },
    url: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      'fullFrame': 'frame/fullFrame',
      'threeDimensionHall': 'frame/threeDimensionHall',
      baseInfo: 'baseInfo'
    }),
    dealerId () {
      return this.baseInfo.dealerId;
    },
    interUrl () {
      const eid = '2|1211004|72|102|203475|301135|20191115004';
      const frompvareaid = this.$queryParams.pvAreaId;
      var _url = this.url;
      _url = _url.replace('https://pano.autohome.com.cn', config.pano);
      if (this.interiorSpecId) {
        _url = `${config.pano}/car/pano/${this.interiorSpecId}?clean=1&_iframe=1&noswitch=1`;
      }
      const urlSerivce = new URLService(_url);
      const dealerId = this.dealerId;
      urlSerivce.queryParams
        .append('dealerId', dealerId)
        .append('eid', eid)
        .append('pvareaid', 2594195)
        .append('frompvareaid', frompvareaid)
        .append('busi', 'dealer4s');
      const targetUrl = urlSerivce.build();
      return targetUrl;
    }
  },
  methods: {
    closeInter () {
      if (this.threeDimensionHall.isOpen) {
        layerManager.open3dLayer();
      }
      layerManager.close(layerNames.CAR_INTERIOR_LAYER);
    }
  }
};
</script>